// extracted by mini-css-extract-plugin
export const wrapper = "maintenance-module--wrapper--1yqYt";
export const subText = "maintenance-module--sub-text--3Jez5";
export const appStore = "maintenance-module--app-store--12oN_";
export const logosContainer = "maintenance-module--logos-container--2agNk";